import React from "react"
import useFeatureFlag from "services/featureFlags"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import { Form } from "sharedTypes"
import EditorSection from "components/Builder/components/EditorSection"
import { Control, UseFormSetValue } from "react-hook-form"
import { Text } from "@chakra-ui/react"
import MessagingSection from "../EditFormModalContent/EditFormModalSettings/Messaging"
import formatRegistrationFields from "../../RegistrationFields/formatRegistrationFields"
import RegistrationSettingsSwitches from "../../RegistrationFields/RegistrationSettingsSwitches"

type Props = {
  form: Form
  control: Control
  setValue: UseFormSetValue<any>
}

const MessagingSettings = ({
  form, control, setValue,
}: Props) => {
  const { whatsappMessaging } = useFeatureFlag()
  const fields = formatRegistrationFields(form, true, { whatsappMessaging })

  return (
    <>
      <SidePanelHeader>Registration</SidePanelHeader>
      <EditorSection>
        <Text fontSize="lg" fontWeight="bold">Additional Registration Fields</Text>
        <Text mb={4}>You can allow guests to complete their profile by
          enabling additional fields.
        </Text>
        <Text mb={6}>If there is existing data, the fields will prepopulate, allowing
          the guest to edit their profile.
        </Text>
        <RegistrationSettingsSwitches
          fields={fields}
          control={control}
          setValue={setValue}
          syncPhoneWithWhatsappOptIn={whatsappMessaging}
        />
      </EditorSection>
      <MessagingSection form={form} />
    </>
  )
}

export default MessagingSettings
